// extracted by mini-css-extract-plugin
module.exports = {"root":"PreviewSwitcher_root__2gIBY","switch":"PreviewSwitcher_switch__11hy-","disbled":"PreviewSwitcher_disbled__3g75n"};